import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

import { timeZoneDefault } from '@/utils/PortalConstants';

const defUser: openapi.UserProfileReadContentOpenapi = {
  first_name: '',
  last_name: '',
  email: '',
  timezone: timeZoneDefault,
  // TODO `is_staff` is returned by server
};

const usePrivateUserStore = defineStore('_user', () => {
  const user = ref(_cloneDeep(defUser));
  function $reset(): void {
    user.value = _cloneDeep(defUser);
  }
  return { user, $reset };
});

export const useUserStore = defineStore('user', () => {
  const _userStore = usePrivateUserStore();

  function $reset(): void {
    _userStore.$reset();
  }

  const user = computed(() => _userStore.user);

  function setUser(user: openapi.UserProfileReadContentOpenapi): void {
    _userStore.user = user;
  }

  function removeUser(): void {
    _userStore.$reset();
  }

  return {
    $reset,
    user,
    setUser,
    removeUser,
  };
});
